import { useRecoilValue } from 'recoil';
import { Navigate, useParams } from 'react-router-dom';
import { accountSelectedSelector } from 'atoms';
import ServiceOrderDetails from 'components/ServiceOrderDetails';

function ServiceOrderDetailsPage() {
  const { serviceOrderId } = useParams();
  const accountSelected = useRecoilValue(accountSelectedSelector);

  if (!accountSelected) {
    return <Navigate to="/" />;
  }

  return <ServiceOrderDetails account={accountSelected} serviceOrderId={Number(serviceOrderId)} />;
}

export default ServiceOrderDetailsPage;
